import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftPanelComponent } from './left-panel/left-panel.component';
import { RightPanelComponent } from './right-panel/right-panel.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LeftPanelComponent,
    RightPanelComponent
  ],
  exports: [
    LeftPanelComponent,
    RightPanelComponent
  ]
})
export class PanelsModule { }
